<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Open New Ticket</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Address Change Request</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                <div class="card-tools">
                  <h3 class="card-title">
                    Home address/location change request
                  </h3>
                </div>
              </div>

              <form
                @submit.prevent="sendAddressChangeRequest"
                method="POST"
                novalidate
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="post_code">Post Code</label>
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            id="post_code"
                            v-model="ticket.post_code"
                            placeholder="Enter Post code..."
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary"
                              type="button"
                              v-on:click="get_available_addresses"
                            >
                              Load address
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="new_address"
                          >Pick your destination address</label
                        >

                        <multiselect
                          v-model="ticket.new_address"
                          :options="currentOptions"
                          :custom-label="(opt) => opt.label"
                          track-by="name"
                          placeholder="Select"
                          :searchable="true"
                          :multiple="false"
                          :class="{
                            'has-error': errors.has('new_address'),
                          }"
                          id="new_address"
                          v-validate="'required'"
                          name="new_address"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3">
                      <button type="submit" class="btn btn-dark-blue">
                      
                        Submit Request
                      </button>
                    
                    </div>
                  </div>
                </div>
              </form>
              <div class="overlay" v-if="is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<style scoped>
div.card-body label {
  font-weight: 12;
  display: inline-flex;
}

button.btn-common {
  width: 100%;
  display: inline-flex;
  justify-content: center;
  background-color: #3c206b !important;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "DataUsage",
  metaInfo: {
    title: "Address Change Request | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    ticket: {
      post_code: "",
      fullName: "",
      customer_email: "",
      phone: "",
      // title: "",
      // body: "",
      cuid: "",
    },

    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    preloadOptions: {},
    currentOptions: [],
    is_loading: false,
    has_permission: true,
  }),
  // method is called after page load
  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }

    this.getAccountDetail();

  },
  methods: {
    getAddressOptions(addressList) {
      let optionList = [];
      if (addressList && addressList.length > 0) {
        for (const address of addressList) {
          let option = {};
          option.name = address.alk;
          let optionLabels = [];
          if (address.subBuilding != "") {
            optionLabels.push(address.subBuilding);
          }

          if (address.buildingName != "") {
            optionLabels.push(address.buildingName);
          }

          if (address.buildingNumber != "") {
            optionLabels.push(address.buildingNumber);
          }

          if (address.street != "") {
            optionLabels.push(address.street);
          }

          if (address.postTown != "") {
            optionLabels.push(address.postTown);
          }

          if (address.postCode != "") {
            optionLabels.push(address.postCode);
          }

          if (optionLabels.length > 0) {
            option.label = optionLabels.join(", ");
          }
          optionList.push(option);
        }
      }

      return optionList;
    },

    get_available_addresses: function () {
      let _this = this,
        postCode;
      postCode = _this.ticket.post_code;
      if (postCode != "" && postCode.length >= 3) {
        _this.is_loading = true;
        let api_url = "/get-address";
        axios
          .get(`/get-address/${postCode}`)
          .then((response) => {
            console.log("response.data::", response.data);
            if (response.data.status == true) {
              let addressList = response.data.address;
              addressList = this.getAddressOptions(addressList);
              console.log("Address List::", addressList);
              _this.currentOptions = addressList;
              _this.$forceUpdate();
              console.log("_this.preloadOptions::", _this.preloadOptions);
            }

            _this.is_loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
            _this.is_loading = false;
          });
      }
    },

    getAccountDetail: function () {
      let api_url = "/get-account-info";
      let _this = this;
      _this.is_loading = true;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        axios
          .get(api_url, { params: { cuid: subscriber.username } })
          .then((response) => {
            //console.log('response.data::', response.data);
            _this.ticket.fullName =
              response.data.firstName + " " + response.data.lastName;
            _this.ticket.customer_email = response.data.email;
            _this.ticket.phone = response.data.phone;
            _this.ticket.cuid = response.data.cuid;
            _this.is_loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
            _this.is_loading = false;
          });
      }
    },

    sendAddressChangeRequest() {
      console.log("Ticekt Data::", this.ticket);
      //this.ticket.new_address;
      this.ticket.alk = this.ticket.new_address.name;
      this.ticket.address = this.ticket.new_address.label;
      console.log("Ticekt Data::", this.ticket);
      //return;
      let _this = this;
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/send_address_change_request";
          let method = "POST";
          // console.log(this.ticket);
          axios({
            method: method,
            url: api_url,
            data: _this.ticket,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              Object.keys(_this.ticket).forEach((key) => {
                _this.ticket[key] = null;
              });
              setTimeout(()=>{
                _this.$router.push({name: 'support-ticket'});
              }, 3500);
            })
            .catch((errors) => {
              // console.log("Errors:::", errors);
              console.log(errors.response.data);
              // _this.$setErrorsFromResponse(errors.response.data);
              // _this.$setErrorsFromResponse(errors.response.data.errors);
              _this.$toaster.error("Something went wrong. Please, contact with system administrator.");
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          console.log("Validation failed");
        }
      });
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getUsageData() {},

    getUsers() {},

    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.api_url, {
            params: query,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.has_permission = false;
            }
            reject(error);
          });
      });
    },
  },
};
</script>
